import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import useAvatar from '~/modules/common/components/Avatars/UserAvatar/useAvatar';
import { useMeContext } from '~/modules/me/useMeContext';
import AvatarUploadDialogContent from './AvatarUploadDialogContent';
import AvatarUploadDialogRemoveButton from './AvatarUploadDialogRemoveButton';

const useStyles = makeStyles(theme => ({
  cancelButton: {
    marginRight: theme.spacing(1)
  },
  removeButton: {
    color: theme.palette.error.main,
    marginLeft: theme.spacing(1)
  }
}));

const avatarUploadDialogRole = {
  role: 'presentation'
};

const AvatarUploadDialog = ({ isOpen, onClose, userUri }) => {
  const {
    featureFlags: { isPsaPrpWcagFixesQ4Enabled }
  } = useMeContext();

  const classes = useStyles();

  const avatarUrl = useAvatar({ userUri, size: 'medium' });

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      TransitionProps={avatarUploadDialogRole}
      {...(isPsaPrpWcagFixesQ4Enabled && {
        'aria-labelledby': 'AvatarUploadDialogTitle',
        'aria-describedby':
          'AvatarUploadDialogContents AvatarUploadDialogActions'
      })}
    >
      <DialogTitle id="AvatarUploadDialogTitle">
        <FormattedMessage id="avatarUploadDialog.title" />
      </DialogTitle>
      <DialogContent id="AvatarUploadDialogContents">
        <AvatarUploadDialogContent
          userUri={userUri}
          onUploadComplete={onClose}
        />
      </DialogContent>
      <DialogActions id="AvatarUploadDialogActions">
        {avatarUrl && (
          <AvatarUploadDialogRemoveButton
            className={classes.removeButton}
            userUri={userUri}
            onRemove={onClose}
          />
        )}
        <Button className={classes.cancelButton} onClick={onClose}>
          <FormattedMessage id="button.cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AvatarUploadDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userUri: PropTypes.string.isRequired
};

export default AvatarUploadDialog;
